import React, { useEffect, useState } from 'react';
import { Row, Col, Typography, Spin, Divider, List, Space, Flex, Button } from 'antd';
import BlogCard from '~/components/Blog/BlogCard';
import Link from 'antd/lib/typography/Link';
import { CalendarOutlined, LoadingOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import useHome from '../hooks/useBlog';
import '../style.css'
import { useBlogDetail } from '~/hooks/blog/useBlogDetail';

const { Title, Paragraph, Text } = Typography;

const BlogDetail = () => {
  const { id } = useParams();
  const { blogs } = useHome()
  // const [blog, setCurrentBlog] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const {data: blog} = useBlogDetail(id)
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  useEffect(() => {
    if (blogs && blogs.data.length > 0 && id) {
      const relatedBlogs = blogs.data.filter(blog => blog.documentId !== id).slice(0, 4);
      setRelatedBlogs(relatedBlogs);
    }
  }, [id, blogs]);
 
  if (!blog) {
    return <Spin style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />;
  }

  const ContentRenderer = ({ content }) => {
    if (!content) return null;

    const renderChildren = (children) => {
      return children.map((child, index) => {
        let node = <>{child.text}</>;
        if (child.bold) {
          node = <strong>{node}</strong>;
        }
        if (child.type === 'link') {
          return <Link href={child.url} key={index} target="_blank" rel="noopener noreferrer">{renderChildren(child.children)}</Link>;
        }
        return <React.Fragment key={index}>{node}</React.Fragment>;
      });
    };

    return content.map((block, index) => {
      switch (block.type) {
        case 'heading':
          return (
            <Title level={4} key={index} style={{ fontWeight: 700, marginTop: '2rem', marginBottom: '1rem', color: 'var(--text)' }}>
              {renderChildren(block.children)}
            </Title>
          );
        case 'paragraph':
          return <Paragraph key={index} style={{ fontSize: 16, lineHeight: 1.8, color: 'var(--muted-2)' }}>{renderChildren(block.children)}</Paragraph>;
        case 'list':
          const items = block.children.map((listItem, i) => (
            <List.Item key={i} style={{ borderBlockEnd: 'none', padding: '4px 0' }}>
              <Text style={{ fontSize: 17, lineHeight: 1.8, color: 'var(--muted-2)' }}>• {renderChildren(listItem.children)}</Text>
            </List.Item>
          ));
          return <List key={index} style={{ marginBottom: '1rem' }}>{items}</List>;
        default:
          return null;
      }
    });
  };

  return (
    <section className='blog-detail'>
      <div className='blog-detail-section' style={{ 
        maxWidth: 1400,
        borderRadius: 16
      }}>
        <Row gutter={[48, 32]} justify="center">
          <Col xs={24} lg={18}>
            <article>
              <Title level={1} style={{ fontWeight: 800, color: 'var(--text)', marginBottom: 16,  }}>
                {blog.title}
              </Title>
              <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
                <Text type="secondary" style={{ fontSize: 15, display: 'flex', alignItems: 'center' }}>
                  <UserOutlined style={{ marginRight: 8 }} /> {blog.author}
                </Text>
                <Text type="secondary" style={{ fontSize: 15, display: 'flex', alignItems: 'center' }}>
                  <CalendarOutlined style={{ marginRight: 8 }} /> {new Date(blog.date).toLocaleDateString('vi-VN')}
                </Text>
              </div>
              <Divider style={{ marginBottom: 24 }} />
              
              {blog?.image?.url && (
                 <img
                    src={blog?.image?.url}
                    alt={blog.title}
                    style={{
                      width: '100%',
                      height: 'auto',
                      maxHeight: 450,
                      objectFit: 'cover',
                      borderRadius: 12,
                      marginBottom: 32,
                    }}
                  />
              )}
             
              <ContentRenderer content={blog.content} />
            </article>
          </Col>

          <Col xs={24} lg={6}>
            <div style={{ position: 'sticky', top: 20 }}>
              <Title level={4} style={{ fontWeight: 700, marginBottom: 24, borderLeft: '4px solid #F9A825', paddingLeft: 12 }}>
                  Bài viết khác
              </Title>
              <Row gutter={[16, 16]}>
                {relatedBlogs.map(item => (
                  <Col span={24} key={item.id}>
                    <BlogCard blog={item} />
                  </Col>
                ))}
                <Col span={24} style={{ textAlign: 'right', marginTop: '8px' }}>
                  <Link style={{ color: '#666'}} href='/blog'>Xem thêm <RightOutlined/></Link>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default BlogDetail;